// src/components/strumenti/EnergiaAcqua.js — W442. Energia e costo per scaldare l'acqua
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, Avviso, euro, fmt } from "./UiStrumento";
import { energiaAcqua } from "../../utils/calcoliStrumenti";

export default function EnergiaAcqua() {
  const { v, set, n, azzera } = useCampi({ litri:"", ti:"15", tf:"45", rend:"100", prezzo:"" });
  const r = energiaAcqua(n("litri"), n("ti"), n("tf"), n("rend"), n("prezzo"));
  return (
    <div>
      <Griglia colonne={3}>
        <Campo etichetta="Litri d'acqua" valore={v.litri} onChange={set("litri")} placeholder="Es. 200"/>
        <Campo etichetta="Temperatura iniziale (°C)" valore={v.ti} onChange={set("ti")}/>
        <Campo etichetta="Temperatura finale (°C)" valore={v.tf} onChange={set("tf")}/>
        <Campo etichetta="Rendimento del generatore (%)" valore={v.rend} onChange={set("rend")} aiuto="Resistenza elettrica ≈ 100%; caldaia: vedi scheda."/>
        <Campo etichetta="Prezzo energia (€/kWh, facoltativo)" valore={v.prezzo} onChange={set("prezzo")} placeholder="Es. 0,25"/>
      </Griglia>
      {n("tf") <= n("ti") && v.tf !== "" && <Avviso>La temperatura finale deve essere più alta di quella iniziale.</Avviso>}
      <Risultato settore="idraulico" titolo="Energia necessaria" valore={fmt(r?.kwh, 2)} unita="kWh"
        righe={r ? [["Energia ceduta all'acqua", fmt(r.kwhUtili, 2) + " kWh"], r.costo !== null && ["Costo", euro(r.costo)]] : []}/>
      <Formula>kWh = litri × 1,163 × ΔT ÷ 1000 ÷ rendimento (1,163 Wh scaldano un litro d'acqua di 1 °C). Con una pompa di calore dividi l'energia utile per il COP invece che per il rendimento. Non considera le dispersioni dell'accumulo.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
